import styled from 'styled-components';
import { BdsPaper } from 'blip-ds/dist/blip-ds-react';
import { ContainerFullWidth } from 'components/Global/components';
import { FadeIn } from 'components/Global/animations';

export const MeuConsumptionContainer = styled(ContainerFullWidth)`
  grid-template-areas: 'sidebar content';
  grid-template-columns: 1fr 3fr;
  animation: ${FadeIn} ease-in 0.5s;
  animation-iteration-count: 1;
`;

export const MeuConsumptionPaper = styled(BdsPaper)`
  margin-bottom: 2rem;
  padding: 1.5rem;
  animation: ${FadeIn} ease-in 0.5s;
  animation-iteration-count: 1;

  > bds-typo + bds-typo {
    display: block;
    margin-top: 8px;
    margin-bottom: 24px;
  }

  & .activeMius {
    width: 40%;
  }

  & .activeMius-thumbnail {
    float: left;
  }

  & .activeMius-content {
    float: left;
    margin-left: 8px;
    width: 50%;
    font-weight: bold;
    white-space: nowrap;
  }

  & .activeMius-child {
    float: left;
    margin-left: 8px;
    width: 50%;
    white-space: nowrap;
  }
`;

export const MeuConsumptionConsolidatedRow = styled.div`
  display: flex;
  width: 100%;
  gap: 32px;
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;

export const MeuConsumptionConsolidatedContent = styled.div`
  padding: 1rem;
  border-radius: 8px;
  white-space: nowrap;
  height: 104px;
  display: flex;
  flex-direction: column;
  flex: 1 1 0%;

  & > bds-typo:first-of-type {
    margin-bottom: 8px;
    display: inline-block;
  }
`;
